// Model.js
// -----------------------
// @module Case
define("Ames.InventoryOverride.InventoryOverride.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
});
});
